import environment from "constants/apiConst";
import { __Post } from "request/Petitions/__Post";

/**
 * Cambia el estado de un pesaje
 * @param {Object} statusData - Datos del estado a cambiar
 * @param {string} statusData.status - Nuevo estado del pesaje
 * @param {string} token - Token de autenticación
 * @param {Function} openAlert - Función para mostrar alertas
 * @param {boolean} Reload - Estado actual de recarga
 * @param {Function} setReload - Función para cambiar el estado de recarga
 * @param {Function} setFormStatus - Función para actualizar el estado del formulario
 * @param {boolean} ReloadContent - Si debe recargar el contenido (opcional, default: false)
 * @param {Function} onRefresh - Callback opcional para refrescar los datos sin recargar la página
 * @returns {Promise<void>}
 */
export const ChangeStatusWeight = async (
  statusData,
  token,
  openAlert,
  Reload,
  setReload,
  setFormStatus,
  ReloadContent = false,
  onRefresh = null
) => {
  // Validación de parámetros requeridos
  if (!statusData || !statusData.status) {
    openAlert("Datos de estado requeridos", "error");
    return;
  }

  if (!token) {
    openAlert("Token de autenticación requerido", "error");
    return;
  }

  if (typeof openAlert !== 'function') {
    console.error("openAlert debe ser una función");
    return;
  }

  try {
    const response = await __Post(
      environment.CHANGE_STATUS_WEIGHING,
      token,
      statusData
    );

    // Verificar que la respuesta tenga la estructura esperada
    if (!response || !response.data) {
      openAlert("Respuesta inválida del servidor", "error");
      return;
    }

    const responseData = response.data.status || response.data;
    
    // Verificar que la respuesta tenga el código de estado
    if (!responseData || typeof responseData.code !== 'number') {
      openAlert("Formato de respuesta inválido", "error");
      return;
    }

    if (responseData.code === 200) {
      // Éxito
      const statusMessage = statusData.status.toLowerCase();
      openAlert(`Ha sido ${statusMessage}`, "success");
      
      // Actualizar el estado del formulario si se proporciona la función
      if (typeof setFormStatus === 'function' && responseData.data?.status) {
        setFormStatus((prev) => ({
          ...prev,
          status: responseData.data.status
        }));
      }
      
      // Llamar al callback de refresco si está disponible (preferido sobre recargar la página)
      if (typeof onRefresh === 'function') {
        onRefresh();
      }
      // Recargar contenido si es necesario (solo si no hay callback de refresco)
      else if (ReloadContent && typeof setReload === 'function') {
        setReload(!Reload);
        // Refresh the page
        setTimeout(() => {
          console.log('Refreshing page');
          window.location.reload();
        }, 3000);
      }
    } else {
      // Error del servidor
      const errorMessage = responseData.message || "Error desconocido del servidor";
      openAlert(errorMessage, "error");
    }
  } catch (error) {
    console.error("Error en ChangeStatusWeight:", error);
    
    // Manejo específico de diferentes tipos de errores
    if (error.response) {
      // Error de respuesta del servidor
      const errorMessage = error.response.data?.message || 
                          error.response.data?.error || 
                          `Error del servidor: ${error.response.status}`;
      openAlert(errorMessage, "error");
    } else if (error.request) {
      // Error de red
      openAlert("Error de conexión. Verifique su conexión a internet", "error");
    } else {
      // Error general
      openAlert("Hubo un error inesperado", "error");
    }
  }
  finally {
    console.log('finally');
    // Refresh the page
    setTimeout(() => {
      console.log('Refreshing page');
      // window.location.reload();
      // debe refrescar el componente TbodyMenuWeigh
      //setReload(!Reload);
    }, 3000);
  }
};
